const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		preventSortOfField: {
			tags: true,
			active: true,
			specialOffer: true
		},
		buttonContext: 'productPromptAssociation',
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		maxNrOfExportElements: 500000,
		privilegeBase: 'mblx_products',
		rowActions: {},
	},

	model: {
		manualPromptDecisions: null,
		resourceFilters: {
			order: [{
				fieldCode: 'productID',
				direction: 'asc'
			}]
		}
	},

	methods: {

		init(){
			if(this.model.manualPromptDecisions){
				return;
			}

			let modal
			this.closest('base_modal_modal', p => modal = p)
			if(!modal) return;

			const {
				manualPromptDecisions = {},
			} = (modal.model || {}).decisionScope || {}

			this.model.manualPromptDecisions = manualPromptDecisions
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){

			if(actionKey === 'refreshResources'){
				// TODO: find a better place for this some day.
				this.init()

				resourceFilters = resourceFilters || {}
				resourceFilters.manualPromptDecisions = this.model.manualPromptDecisions
			}

			return resourceFilters;
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			const nrOfManualPromptDecisions = utils.collectionSize((resourceFilters || {}).manualPromptDecisions)
			return actionKey !== 'refreshResources' || nrOfManualPromptDecisions > 0
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		async showEdit(rowID, rowData, buttonMode){
			const attributes = (rowData || {}).attributes || {}
			return this.choosePrompt(attributes.number, attributes)
		},

		async choosePrompt(productNumber, productAttributes){
			if(!productNumber) return;

			let controller
			this.closest('templates_mblx_products_promptAssociations_controller', c => controller = c)

			if(!controller) return;

			const promptDecision = await controller.choosePrompt(productNumber, productAttributes)
			this.model.manualPromptDecisions[productNumber] = {
				...(this.model.manualPromptDecisions[productNumber] || {}),
				...(promptDecision || {}),
			}
			this.refreshData(true)
		},

		async chooseAll(){

			let nrOfEntities, afterLazyLoadNrOfEntities
			do {
				const manualPromptDecisions = this.model.manualPromptDecisions || {}
				for(const [,{attributes = {}}] of Object.entries(this.model.entityList || {})){
					const productNumber = attributes.number || '~~~MISSING-PRODUCT-NUMBER~~~'
					if((manualPromptDecisions[productNumber] || {}).decision === 'outstanding'){
						await this.choosePrompt(productNumber, attributes)
					}
				}

				// TODO: fuck these delays
				await utils.promise.delayed(100)
				nrOfEntities = utils.collectionSize(this.model.entityList)

				await this.lazyloadNext()

				await utils.promise.delayed(100)
				afterLazyLoadNrOfEntities = utils.collectionSize(this.model.entityList)
			} while(nrOfEntities < afterLazyLoadNrOfEntities)

			// run generate if possible
			let modal
			this.closest('base_modal_modal', m => modal = m)
			if(!modal) return;
			modal.processDecision(undefined, 'decisionComponent', 'generate')
		},
	},

	hooks: {
		async onDecision($element, options){
			let modal
			switch(options.decisionComponent.componentClass) {
				case 'base_modal_modal':
				case 'templates_modal_modal':
					modal = options.decisionComponent
					break
			}

			let controller
			this.closest('templates_mblx_products_promptAssociations_controller', c => controller = c)

			if(!modal){
				console.error('MISSING MODAL')
				return
			}

			if(options.decisionType !== 'decisionComponent' || !controller){
				return modal.hide()
			}

			controller.decideClosest(this.model.manualPromptDecisions)
			await modal.hide()
		}
	},
}